import React from 'react';

const StatsSection = ({ onApplyClick }) => {
  return (
    <div className="bg-[#2E237B] text-white pt-6 pb-7 md:pb-0 px-5  border-b-8 border-white">
      <div className="mx-auto px-4 md:px-8">
        {/* <div className="grid grid-cols-1 md:grid-cols-5 gap-5 text-center">
          // Stat Cards
          {[
            {
              icons: 'assets/placement/1.png',
              title: 'Top 200',
              subtitle: 'World Universities with Real Impact',
            },
            {
              icons: 'assets/placement/2.png',
              title: '$160M+',
              subtitle: 'Received in Research Grants',
            },
            {
              icons: 'assets/placement/3.png',
              title: '650+',
              subtitle: 'Industry Partnerships',
            },
            {
              icons: 'assets/placement/4.png',
              title: '5000+',
              subtitle: 'Research Publications',
            },
            {
              icons: 'assets/placement/1.png',
              title: '22,000+',
              subtitle: 'Students On-campus',
            },
          ].map((stat, index) => (
            <div
              key={index}
              className="bg-[#0b0b24] p-5 rounded-lg flex flex-col items-center border-2 border-white"
            >
              <img src={stat.icons} alt="Icons" className="h-16 mb-5" />
              <h2 className="text-2xl font-bold">{stat.title}</h2>
              <p className="text-xl mb-6 mt-2">{stat.subtitle}</p>
            </div>
          ))}
        </div> */}

        {/** Apply Now Section */}
        <div className="mt-0 pb-4 md:flex">
          <p className="text-lg md:text-2xl w-full pb-4 md:w-[70%]">
            Your future begins here! Click{' '}
            <span className="font-bold">"Apply Now"</span> to embark on an
            enriching educational experience that will shape your career and
            life
            <span className="inline-block border-b-2 border-white w-28 ml-2"></span>
          </p>
          <div className="w-full md:w-[30%] text-center md:text-left pt-[12px]">
            <button
              onClick={onApplyClick}
              className="bg-[#F6A600] duration-300 hover:bg-yellow-600 text-black  text-xl md:text-xl md:font-medium px-20 py-3 rounded-3xl shadow-md transition-all z-20"
            >
              APPLY NOW
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
